import React from 'react';
import CardPrice from '..//card/CardPrice';
import cardUtils from '../../utils/cardUtils';
import CardImage from '../card/CardImage';

const ShoppingCartItem = props => {
  return (
    <div key={props.card.name} className="w-full">
      <div className="flex flex-col bg-mediumColor shadow-md rounded-lg text-gray-700 p-4 gap-y-2">
        <div className="flex flex-col gap-y-2">
          <h4 className="text-xl text-center text-white">{props.card.name}</h4>
          <CardImage card={props.card} />
        </div>
        {cardUtils.sortPrices(props.card.cardPrices)[0] && (
          <div className="flex flex-col gap-y-2">
            <CardPrice
              card={props.card}
              price={cardUtils.sortPrices(props.card.cardPrices)[0]}
              removeFromCart={props.onRemoveCardFromCart}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingCartItem;
